import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-blue-600 text-white">
          <div className="container mx-auto px-6 py-24 text-center">
            <h1 className="text-5xl font-extrabold mb-4">{t('home.hero.title')}</h1>
            <p className="text-xl mb-8">{t('home.hero.subtitle')}</p>
            <div className="space-x-4">
              <Link to="/dashboard" className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-md hover:bg-gray-100">
                {t('home.hero.ctaPrimary')}
              </Link>
              <Link to="/contact" className="px-8 py-3 bg-blue-800 text-white font-semibold rounded-md hover:bg-blue-900">
                {t('home.hero.ctaSecondary')}
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">{t('home.features.title')}</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h3 className="text-xl font-bold mb-2">{t('home.features.feature1')}</h3>
                <p className="text-gray-600">{t('home.features.feature1_desc')}</p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h3 className="text-xl font-bold mb-2">{t('home.features.feature2')}</h3>
                <p className="text-gray-600">{t('home.features.feature2_desc')}</p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h3 className="text-xl font-bold mb-2">{t('home.features.feature3')}</h3>
                <p className="text-gray-600">{t('home.features.feature3_desc')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="bg-white py-20">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">{t('home.about.title')}</h2>
            <p className="text-lg text-gray-600 mb-6 max-w-3xl mx-auto">{t('home.about.subtitle')}</p>
            <p className="text-gray-700 max-w-2xl mx-auto">{t('home.about.content')}</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
